<template>
  <div class="home" style="height:100vh;overflow:hidden">
      <vxe-grid
          border
          stripe
          resizable
          show-overflow
          show-footer
          show-header
          :height="screenHeight-50"
          :style="'width:'+screenWidth-20"
          ref="xTable"
          row-id="id"
          size="mini"
          align="center"
          :data="ws"
          :columns="tableColumn"
          :export-config="{}"
          :print-config="{}"
          >
        </vxe-grid>
    <div @click="exbillTo">
        导出
    </div>
  </div>
</template>

<script>
  
  import Axios from "axios";
  export default {
    components:{
    },
    data(){
      return{
          obj:{},
          tableColumn:[{ type: 'seq', title:'序号',width:50}],
          ws:[],
          screenWidth : window.innerWidth,
          screenHeight : window.innerHeight,
      }
    },
    computed: {
       
    },
    created(){
        this.getOne()
    },
    destroyed() {
    },
    mounted(){
        this.screenHeight = window.innerHeight;
		this.screenWidth = window.innerWidth;
        	window.onresize = () => {
				return (() => {
    			    this.screenWidth = window.innerWidth;
					this.screenHeight = window.innerHeight;
				})();
			};
    },
    methods:{
        exbillTo(){
            this.$refs.xTable.exportData()
        },
     getOne(){
         this.obj=JSON.parse(localStorage.getItem('agtexbillOne'))
         this.ws=JSON.parse(localStorage.getItem('agtexbillOne')).ws
        //  console.log('1111',this.obj)
         let head=JSON.parse(localStorage.getItem('agtexbillOne')).detail.head
         let body=JSON.parse(localStorage.getItem('agtexbillOne')).detail.body
         this.ws.forEach((el,index)=>{
             if(el['序号'].indexOf('#单体')!=-1){
                 for(let i in this.ws[index]){
                    //  console.log(i)
                    if(i!='序号'){
                        let item={ field: i, title:i,align: this.ws[index][i].split('#')[2]}
                        this.tableColumn.push(item)
                    }
                    
                }
             }
         })
         
         let dtindex=0
         this.ws.forEach((el,index)=>{
             for(let i in el){
                 if(el[i]=='#供方名称#'){el[i]=head.fcsname}
                 if(el[i]=='#发货地址#'){el[i]=head.fcsaddress}
                 if(el[i]=='#备注说明#'){el[i]=head.fremark}
                 if(el[i]=='#交付日期#'){el[i]=head.fdateplan}
                 if(el[i]=='#付款方式#'){el[i]=head.fpaystyle}
                 if(el[i]=='#联系人#'){el[i]=head.fcslinkor}
                 if(el[i]=='#单据日期#'){el[i]=head.fdate}
                 if(el[i]=='#付款日期#'){el[i]=head.fdatepay}
                 if(el[i]=='#联系电话#'){el[i]=head.fcsphone}
                 if(el[i]=='#单据编号#'){el[i]=head.fbillno}
                 if(el[i]=='#自编单号#'){el[i]=head.fselfno}
                 if(el[i]=='#仓库#'){el[i]=head.fstockname}
                 if(el[i]=='#制单#'){el[i]=head.fcreatorname}
                 if(el[i]=='#评审#'){el[i]=head.frevieworname}
                 if(el[i]=='#审核#'){el[i]=head.fauditorname}
                 if(el[i]=='#采购员#'){el[i]=head.fworkername}
                 if(el[i].indexOf('#单体')!=-1){
                     el[i]=el[i].split('#')[0]
                     dtindex=index
                 }
            }
         })
         setTimeout(() => {
             let arrbody=[]
                console.log(this.ws[dtindex])
            body.forEach((el,index)=>{
                let item={}
                for(let i in this.ws[dtindex]){
                    
                    if(this.ws[dtindex][i]=='商品名称'){item[i]=el.fdataname}
                    if(this.ws[dtindex][i]=='型号规格'){item[i]=el.fdatamodel}
                    if(this.ws[dtindex][i]=='商品编码'){item[i]=el.fdataassis}
                    if(this.ws[dtindex][i]=='颜色'){item[i]=el.fcolorname}
                    if(this.ws[dtindex][i]=='包装标准'){item[i]=el.fpackname}
                    if(this.ws[dtindex][i]=='包装数量'){item[i]=el.fpackqty}
                    if(this.ws[dtindex][i]=='总数量'){item[i]=el.fqty}
                    if(this.ws[dtindex][i]=='单位'){item[i]=el.funitname}
                    if(this.ws[dtindex][i]=='单价'){item[i]=el.fprice}
                    if(this.ws[dtindex][i]=='金额'){item[i]=el.famount}
                    if(this.ws[dtindex][i]=='预定交期'){item[i]=el.fdateplan}
                    if(this.ws[dtindex][i]=='议定交期'){item[i]=el.fdatedecide}
                    if(this.ws[dtindex][i]=='备注'){item[i]=el.fremark}
                    // arrbody.push(item)
                     
                   
                }
                this.ws.splice(dtindex+1+index,0,item)
                // if(index==body.length-1){
                //      console.log(arrbody)
                //     this.ws.splice(dtindex+1,0,arrbody)
                //     console.log(this.ws)
                // }
            })
            
            // setTimeout(()=>{
            //     console.log(arrbody)
            //     this.ws.splice(dtindex+1,0,arrbody)
            // },200)
            let arrtemp=this.ws
            this.ws.forEach((el,index)=>{
                let sum=0
                for(let i in el){
                    
                    sum++
                }
                if(sum==2){
                    console.log(index,el)
                    this.ws.splice(index,1)
                }
            })
         }, 500);
         
     },
    }
  }
</script>

<style lang="scss" scoped>
  
</style>


// WEBPACK FOOTER //
// src/views/export/exbill.vue